import React from 'react';

/** @internal */
export var checkmarkIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "106",
  height: "106",
  viewBox: "0 0 106 106",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.0001 101.583C79.8319 101.583 101.583 79.8319 101.583 53.0001C101.583 26.1682 79.8319 4.41675 53.0001 4.41675C26.1682 4.41675 4.41675 26.1682 4.41675 53.0001C4.41675 79.8319 26.1682 101.583 53.0001 101.583Z",
  strokeWidth: "4",
  fill: "none",
  className: "sicl-icon-stroke-color"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49 75.5015L27.1394 53.7654C26.2869 52.8408 26.2869 51.3416 27.1394 50.417C27.9919 49.4924 29.3742 49.4924 30.2267 50.417L49 68.5015L80.0209 36.1624C80.8247 35.1586 82.2267 35.0515 83.1524 35.9233C84.078 36.7951 84.1767 38.3156 83.3729 39.3195L49 75.5015Z",
  className: "sicl-icon-stroke-color"
}));